(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ambient-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    class AmbientHeroSlider extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.autoPlayInterval = null;
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.isTransitioning = false;
        this.initialized = false;
      }

      connectedCallback() {
        // 自動再生の間隔（秒）を取得
        const autoRotateInterval = parseInt(this.dataset.autoRotateInterval || 5);
        this.autoPlayDelay = autoRotateInterval * 1000;

        // 初期化を実行
        this.init();
      }

      disconnectedCallback() {
        // クリーンアップ
        this.stopAutoPlay();
      }

      init() {
        if (this.initialized) return;
        
        this.slides = this.querySelectorAll('.ambient-hero-slider__slide');
        this.dots = this.querySelectorAll('.ambient-hero-slider__pagination-dot');
        this.backgroundImageWrappers = this.querySelectorAll('.ambient-hero-slider__background-image-wrapper');
        
        if (this.slides.length <= 1) return;

        this.initialized = true;

        // ドットクリックイベント
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goToSlide(index));
        });

        // タッチイベント
        this.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: true });
        this.addEventListener('touchend', (e) => this.handleTouchEnd(e), { passive: true });

        // マウスイベント（デスクトップでのドラッグ対応）
        this.addEventListener('mousedown', (e) => this.handleMouseDown(e));
        this.addEventListener('mouseup', (e) => this.handleMouseUp(e));
        this.addEventListener('mouseleave', () => this.handleMouseLeave());

        // 自動再生開始
        if (this.autoPlayDelay > 0) {
          this.startAutoPlay();
        }

        // ホバー時に自動再生を一時停止
        this.addEventListener('mouseenter', () => this.stopAutoPlay());
        this.addEventListener('mouseleave', () => this.startAutoPlay());
      }

    goToSlide(index) {
      if (this.isTransitioning || index === this.currentIndex) return;
      if (index < 0 || index >= this.slides.length) return;

      this.isTransitioning = true;

      // 現在のスライドを非表示
      this.slides[this.currentIndex].classList.remove('active');
      this.dots[this.currentIndex].classList.remove('active');
      const currentBgWrapper = Array.from(this.backgroundImageWrappers).find(
        wrapper => parseInt(wrapper.dataset.slideIndex) === this.currentIndex
      );
      if (currentBgWrapper) {
        currentBgWrapper.classList.remove('active');
      }

      // 新しいスライドを表示
      this.currentIndex = index;
      this.slides[this.currentIndex].classList.add('active');
      this.dots[this.currentIndex].classList.add('active');
      const newBgWrapper = Array.from(this.backgroundImageWrappers).find(
        wrapper => parseInt(wrapper.dataset.slideIndex) === this.currentIndex
      );
      if (newBgWrapper) {
        newBgWrapper.classList.add('active');
      }

      // トランジション完了後にフラグをリセット
      setTimeout(() => {
        this.isTransitioning = false;
      }, 800);
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }

    prevSlide() {
      const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.goToSlide(prevIndex);
    }

    startAutoPlay() {
      this.stopAutoPlay();
      if (this.autoPlayDelay > 0) {
        this.autoPlayInterval = setInterval(() => {
          this.nextSlide();
        }, this.autoPlayDelay);
      }
    }

    stopAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
        this.autoPlayInterval = null;
      }
    }

    handleTouchStart(e) {
      this.touchStartX = e.changedTouches[0].screenX;
      this.stopAutoPlay();
    }

    handleTouchEnd(e) {
      this.touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe();
      this.startAutoPlay();
    }

    handleMouseDown(e) {
      this.touchStartX = e.screenX;
      this.stopAutoPlay();
    }

    handleMouseUp(e) {
      this.touchEndX = e.screenX;
      this.handleSwipe();
      this.startAutoPlay();
    }

    handleMouseLeave() {
      this.touchStartX = 0;
      this.touchEndX = 0;
    }

    handleSwipe() {
      const swipeThreshold = 50;
      const diff = this.touchStartX - this.touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // 左にスワイプ（次のスライド）
          this.nextSlide();
        } else {
          // 右にスワイプ（前のスライド）
          this.prevSlide();
        }
      }
      }
    }

    // カスタムエレメントが既に定義されていない場合のみ定義
    if (!customElements.get('ambient-hero-slider')) {
      customElements.define('ambient-hero-slider', AmbientHeroSlider);
    }

    // Shopifyテーマエディタでの動的読み込みに対応
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', (event) => {
        const slider = event.target.querySelector('ambient-hero-slider');
        if (slider && slider.init) {
          slider.init();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
